<template>
  <v-card v-if="typeOfUser === 'Free'" data-testid="financialclose-virtualconcierge-view-free">
    <v-card-text data-testid="financialclose-virtualconcierge-cardtext-free">
        <br>
        <br>
        <br>
        <div class="font-size-lg text-center font-weight-bold" align-center>
                This feature is available on paid version
        </div>
        <br>
        <br>
    </v-card-text>
  </v-card>
  <div class="" v-else data-testid="financialclose-virtualconcierge-view-paid">
    <QueriesListNew :project="project" type="functional" data-testid="financialclose-virtualconcierge-querieslist"></QueriesListNew>
  </div>
</template>

<script>
import QueriesListNew from '../../../views/common/QueriesListNew.vue';
export default {
  name: 'financialclose_virtualconcierge_list',
  // props: ['props'],
  data: function () {
    return {
      project: "",
      typeOfUser: 'Paid',
    }
  },
  components: {
    QueriesListNew
  },
  created() {
    this.init();
  },
  activated() {
    this.init();
  },
  methods: {
    init() {
      this.$store.commit("setProjectName", "");
      this.project = this.$route.params.id;
      if (this.$store.state.subscriptions.financialclose.plan_detail.name) {
        this.typeOfUser = this.$store.state.subscriptions.financialclose.plan_detail.name || "Paid";
      }
    },

  },
  watch: {
  }
}
</script>
